import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import styles from './index.scss'

const cx = classnames.bind(styles)

// having no `width/heght` but keeping `viewBox`
// allows it to keep local coords system and take entire parent container space
const Pin = ({ invert, className }) => (
  <div className={cx('root', { invert }, className)}>
    <svg
      viewBox='0 0 88 100'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <polygon
        className={cx('bg')}
        strokeWidth={5}
        points='88 80 88 0 0 0 0 80 10.0234375 80 10.0234375 100 44.3836835 80'
      />
      <path
        className={cx('fg')}
        d='M52.4848357,57.5994784 L52.4888672,66.1897852 L20.4055339,66.1897852 L20.4055339,49.6736728 L16,49.6736728 L36.1560007,26.3054302 L42.4259967,33.1227471 L47.3883802,33.1252149 L47.4182768,39.6958671 L55.6706486,49.6389951 L52.4810998,49.6388596 L52.4826501,52.9422447 L62.8151138,52.9422447 L50.7163321,38.5467618 L50.6766229,29.8194975 L49.0324959,29.8255543 L49.0324959,10 L72,16.6651982 L72,53.1055523 L52.4848357,57.5994784 Z M35.8194975,21.232788 L35.8194975,16.5555413 L45.6965848,10 L45.6965848,29.8378434 L43.1812711,29.8471095 L35.8194975,21.232788 L35.8194975,21.232788 Z'
      />
    </svg>
  </div>
)

Pin.propTypes = {
  invert: PropTypes.bool,
  className: PropTypes.string,
}

export default Pin
